/**
 * Cart Upsell Slider - Global JavaScript
 * Supports multiple instances via event delegation
 */

window.CartUpsell = {
  
  // Helper to get the slider container from a child element
  getSlider: function(element) {
    return element.closest('[data-upsell-slider]');
  },
  
  // Helper to get the track from the slider
  getTrack: function(slider) {
    return slider.querySelector('[data-upsell-track]');
  },
  
  // Get all items in the slider
  getItems: function(slider) {
    return Array.from(slider.querySelectorAll('.cart-upsell__item'));
  },
  
  // Get current index from data attribute
  getIndex: function(slider) {
    return parseInt(slider.dataset.index) || 0;
  },
  
  // Set index to data attribute
  setIndex: function(slider, index) {
    slider.dataset.index = index;
  },
  
  getItemWidth: function(slider) {
    var items = this.getItems(slider);
    var track = this.getTrack(slider);
    if (!items.length || !track) return 0;
    var gap = parseInt(getComputedStyle(track).gap) || 12;
    return items[0].offsetWidth + gap;
  },
  
  getMaxTranslate: function(slider) {
    var items = this.getItems(slider);
    var track = this.getTrack(slider);
    if (!items.length || !track) return 0;
    var wrapper = track.parentElement;
    var gap = parseInt(getComputedStyle(track).gap) || 12;
    var itemW = items[0].offsetWidth;
    var total = (itemW + gap) * items.length - gap;
    return Math.max(0, total - wrapper.offsetWidth + wrapper.offsetWidth * 0.1);
  },
  
  setPosition: function(slider, animate) {
    var track = this.getTrack(slider);
    if (!track) return;
    
    var index = this.getIndex(slider);
    var itemW = this.getItemWidth(slider);
    var target = -index * itemW;
    var max = -this.getMaxTranslate(slider);
    
    // Ensure we don't scroll past the end
    if (target < max) target = max;
    // Ensure we don't scroll past the start
    if (target > 0) target = 0;
    
    track.style.transition = animate ? 'transform 0.3s ease-out' : 'none';
    track.style.transform = 'translateX(' + target + 'px)';
    
    this.updateButtons(slider);
  },
  
  updateButtons: function(slider) {
    var prevBtn = slider.querySelector('.cart-upsell__nav-btn--prev');
    var nextBtn = slider.querySelector('.cart-upsell__nav-btn--next');
    var items = this.getItems(slider);
    var index = this.getIndex(slider);
    
    if (prevBtn) {
      if (index <= 0) {
        prevBtn.style.display = 'none';
        prevBtn.disabled = true;
      } else {
        prevBtn.style.display = '';
        prevBtn.disabled = false;
      }
    }
    
    if (nextBtn) {
      if (index >= items.length - 1) {
        nextBtn.style.display = 'none';
        nextBtn.disabled = true;
      } else {
        nextBtn.style.display = '';
        nextBtn.disabled = false;
      }
    }
  },
  
  next: function(btn) {
    var slider = this.getSlider(btn);
    if (!slider) return;
    
    var items = this.getItems(slider);
    var index = this.getIndex(slider);
    
    if (index < items.length - 1) {
      this.setIndex(slider, index + 1);
      this.setPosition(slider, true);
    }
  },
  
  prev: function(btn) {
    var slider = this.getSlider(btn);
    if (!slider) return;
    
    var index = this.getIndex(slider);
    
    if (index > 0) {
      this.setIndex(slider, index - 1);
      this.setPosition(slider, true);
    }
  },
  
  init: function() {
    var sliders = document.querySelectorAll('[data-upsell-slider]');
    var self = this;
    
    sliders.forEach(function(slider) {
      // Reset to 0 on init
      self.setIndex(slider, 0);
      self.setPosition(slider, false);
    });
  },
  
  onVariantChange: function(select) {
    var item = select.closest('.cart-upsell__item');
    if (!item) return;
    
    var opt = select.selectedOptions[0];
    if (!opt) return;
    
    var priceEl = item.querySelector('.cart-upsell__current-price');
    var compareEl = item.querySelector('.cart-upsell__compare-price');
    var btn = item.querySelector('.cart-upsell__add-button');
    
    if (priceEl) priceEl.textContent = opt.dataset.price;
    
    if (compareEl) {
      compareEl.style.display = opt.dataset.hasCompare === 'true' ? '' : 'none';
      if (opt.dataset.hasCompare === 'true') {
        compareEl.textContent = opt.dataset.comparePrice;
      }
    }
    
    if (btn) {
      btn.setAttribute('data-variant-id', select.value);
      btn.disabled = opt.disabled;
    }
  },
  
  addToCart: function(button) {
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId || button.disabled) return;
    
    button.disabled = true;
    button.classList.add('loading');
    
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 
        id: parseInt(variantId), 
        quantity: 1, 
        sections: 'cart-drawer,cart-icon-bubble' 
      })
    })
    .then(function(res) { return res.json(); })
    .then(function(data) {
      document.dispatchEvent(new CustomEvent('cart:update', { 
        bubbles: true, 
        detail: { cart: data, data: data } 
      }));
      document.dispatchEvent(new CustomEvent('cart:add', { 
        bubbles: true, 
        detail: { cart: data, data: data } 
      }));
      
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer && drawer.open) drawer.open();
    })
    .catch(function(err) {
      console.error('Cart error:', err);
    })
    .finally(function() {
      button.disabled = false;
      button.classList.remove('loading');
    });
  }
};

// Re-init after cart updates
document.addEventListener('cart:update', function() {
  setTimeout(function() { 
    if (window.CartUpsell) window.CartUpsell.init(); 
  }, 300);
});

document.addEventListener('cart:add', function() {
  setTimeout(function() { 
    if (window.CartUpsell) window.CartUpsell.init(); 
  }, 300);
});

// EVENT DELEGATION
document.addEventListener('click', function(e) {
  // Prev button
  var prevBtn = e.target.closest('.cart-upsell__nav-btn--prev');
  if (prevBtn) {
    e.preventDefault();
    e.stopPropagation();
    if (window.CartUpsell) window.CartUpsell.prev(prevBtn);
    return;
  }
  
  // Next button
  var nextBtn = e.target.closest('.cart-upsell__nav-btn--next');
  if (nextBtn) {
    e.preventDefault();
    e.stopPropagation();
    if (window.CartUpsell) window.CartUpsell.next(nextBtn);
    return;
  }
  
  // Add button
  var addBtn = e.target.closest('.cart-upsell__add-button');
  if (addBtn && !addBtn.disabled) {
    e.preventDefault();
    e.stopPropagation();
    if (window.CartUpsell) window.CartUpsell.addToCart(addBtn);
    return;
  }
}, true);

// Variant change
document.addEventListener('change', function(e) {
  var select = e.target.closest('.cart-upsell__variant-select');
  if (select) {
    if (window.CartUpsell) window.CartUpsell.onVariantChange(select);
  }
}, true);

// Init on load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    if (window.CartUpsell) window.CartUpsell.init();
  });
} else {
  if (window.CartUpsell) window.CartUpsell.init();
}
